export default {
	addPerson: "Adicionar Pessoa",
	editPerson: "Editar Pessoa",
	person: "Pessoa",
	confirmRemovePerson: "Tem certeza que deseja remover esta pessoa?",
	errorLoadingPersons: "Erro ao carregar pessoas",
	errorLoadingAvailablePersons: "Erro ao carregar pessoas disponíveis",
	errorSavingPerson: "Erro ao salvar pessoa",
	errorDeactivatingPerson: "Erro ao desativar pessoa",
	errorActivatingPerson: "Erro ao ativar pessoa",
	errorRemovingPerson: "Erro ao remover pessoa",
	personUpdatedSuccess: "Pessoa atualizada com sucesso",
	personAddedSuccess: "Pessoa adicionada com sucesso",
	personDeactivatedSuccess: "Pessoa desativada com sucesso",
	personActivatedSuccess: "Pessoa ativada com sucesso",
	personRemovedSuccess: "Pessoa removida com sucesso",
};
